const LOGIN_PASSWORD_SET = 'LOGIN_PASSWORD_SET';
const LOGIN_PASSWORD_SET_VALIDATION_MESSAGE = 'LOGIN_PASSWORD_SET_VALIDATION_MESSAGE';
const LOGIN_PASSWORD_SET_VISUALIZATION = 'LOGIN_PASSWORD_SET_VISUALIZATION';
const LOGIN_PASSWORD_SET_FOCUS = 'LOGIN_PASSWORD_SET_FOCUS';
const LOGIN_PASSWORD_BLURRED = 'LOGIN_PASSWORD_BLURRED';
const LOGIN_PASSWORD_FOCUSED = 'LOGIN_PASSWORD_FOCUSED';
const LOGIN_PASSWORD_CHANGE = 'LOGIN_PASSWORD_CHANGE';

const loginPasswordSet = (password) => ({
  type: LOGIN_PASSWORD_SET,
  payload: password
});

const loginPasswordSetvalidationMessage = (payload) => ({
  type: LOGIN_PASSWORD_SET_VALIDATION_MESSAGE,
  payload
});

const loginPasswordSetVisualization = (visualized) => ({
  type: LOGIN_PASSWORD_SET_VISUALIZATION,
  payload: visualized
});

const loginPasswordSetFocus = (focused) => ({
  type: LOGIN_PASSWORD_SET_FOCUS,
  payload: focused
});

const loginPasswordBlur = (markedAsWrong, validationMessage) => ({
  type: LOGIN_PASSWORD_BLURRED,
  payload: { markedAsWrong, validationMessage }
});

const loginPasswordFocus = () => ({
  type: LOGIN_PASSWORD_FOCUSED
});

export {
  loginPasswordSetvalidationMessage,
  loginPasswordSetVisualization,
  loginPasswordFocus,
  loginPasswordSetFocus,
  loginPasswordBlur,
  loginPasswordSet,
  LOGIN_PASSWORD_CHANGE,
  LOGIN_PASSWORD_FOCUSED,
  LOGIN_PASSWORD_BLURRED,
  LOGIN_PASSWORD_SET_FOCUS,
  LOGIN_PASSWORD_SET_VALIDATION_MESSAGE,
  LOGIN_PASSWORD_SET,
  LOGIN_PASSWORD_SET_VISUALIZATION
};
